import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { MembershipButton } from '../../Membership';
import { EmptyState } from '../../EmptyState';

const PrivateComponent: React.FunctionComponent<InjectedTranslateProps> = props => {
  const { t } = props;

  return (
    <EmptyState
      title={t('groups-web.group.private')}
      content={t('groups-web.join.private')}
      button={<MembershipButton biOrigin="group_feed_inside_page_btn" />}
    />
  );
};

export const Private = translate()(PrivateComponent) as React.ComponentType;
